const THREE = window.THREE;
const dat = window.dat;

class Terrain {
  static initClass() {
    this.prototype.uniforms                 = null;
    this.prototype.plane_mesh               = null;
    this.prototype.plane_geometry           = null;
    this.prototype.groundMaterial           = null;
    this.prototype.clock                    = new THREE.Clock(true);
    this.prototype.options  = {
      elevation : 1,
      noise_range  : 2.14,
      sombrero_amplitude : 0.6,
      sombrero_frequency : 0.0,
      speed            : 0.05,
      segments         : 20,
      wireframe_color  : '#FF387A',
      perlin_passes    : 1,
      wireframe        : true,
      floor_visible    : false
    };
    this.prototype.scene  = null;
  }

  constructor(scene){
    this.init = this.init.bind(this);
    this.initGUI = this.initGUI.bind(this);
    this.buildPlanes = this.buildPlanes.bind(this);
    this.update = this.update.bind(this);
    this.scene = scene;
    this.init();
  }

  init() {
    this.uniforms = {
      time: {
        type: "f",
        value: 0.0
      },
      speed: {
        type: "f",
        value: this.options.speed
      },
      elevation: {
        type: "f",
        value: this.options.elevation
      },
      noise_range: {
        type: "f",
        value: this.options.noise_range
      },
      offset: {
        type: "f",
        value: this.options.elevation
      },
      perlin_passes: {
        type: "f",
        value: this.options.perlin_passes
      },
      sombrero_amplitude: {
        type: "f",
        value: this.options.sombrero_amplitude
      },
      sombrero_frequency: {
        type: "f",
        value: this.options.sombrero_frequency
      },
      line_color: {
        type: "c",
        value: new THREE.Color(this.options.wireframe_color)
      }
    };
    this.buildPlanes(this.options.segments);
    return;

    (function(){
      var script=document.createElement('script');
      script.onload=function(){
        var stats=new window.Stats();
        document.body.appendChild(stats.dom);
        requestAnimationFrame(function loop(){
          stats.update();
          requestAnimationFrame(loop)
        });
      }
      script.src='//rawgit.com/mrdoob/stats.js/master/build/stats.min.js';
      document.head.appendChild(script);
    })()
    return this.initGUI();
  }

  initGUI() {
    this.gui                           = new dat.GUI();
    this.gui.values                    = {};
    this.gui.values.speed              = this.gui.add(this.options,'speed',-5,5).step(0.01);
    this.gui.values.segments           = this.gui.add(this.options,'segments',20,800).step(1);
    this.gui.values.perlin_passes      = this.gui.add(this.options,'perlin_passes',1,3).step(1);
    this.gui.values.elevation          = this.gui.add(this.options,'elevation',-10,10).step(0.01);
    this.gui.values.noise_range        = this.gui.add(this.options,'noise_range',-10,10).step(0.01);
    this.gui.values.sombrero_amplitude = this.gui.add(this.options,'sombrero_amplitude',-5,5).step(0.1);
    this.gui.values.sombrero_frequency = this.gui.add(this.options,'sombrero_frequency',0,100).step(0.1);
    this.gui.values.wireframe_color    = this.gui.addColor(this.options,'wireframe_color');
    this.gui.values.wireframe          = this.gui.add(this.options, 'wireframe');
    this.gui.values.floor_visible      = this.gui.add(this.options, 'floor_visible');

    this.gui.values.elevation.onChange(value => {
      this.uniforms.elevation.value = value;
    });

    this.gui.values.wireframe.onChange(value => {
      this.plane_material.wireframe = value;
    });

    this.gui.values.floor_visible.onChange(value => {
      this.groundMaterial.visible = value;
    });

    this.gui.values.noise_range.onChange(value => {
      this.uniforms.noise_range.value = value;
    });

    this.gui.values.speed.onChange(value => {
      this.uniforms.speed.value = value;
    });

    this.gui.values.perlin_passes.onChange(value => {
      this.uniforms.perlin_passes.value = value;
    });

    this.gui.values.sombrero_amplitude.onChange(value => {
      this.uniforms.sombrero_amplitude.value = value;
    });

    this.gui.values.sombrero_frequency.onChange(value => {
      this.uniforms.sombrero_frequency.value = value;
    });

    this.gui.values.wireframe_color.onChange(value => {
      this.uniforms.line_color.value = new THREE.Color(value);
    });

    return this.gui.values.segments.onFinishChange(value => {
      this.scene.remove(this.plane_mesh);
      this.buildPlanes(value);
      this.scene.add(this.plane_mesh);
    });
  }

  buildPlanes(segments){
    this.plane_geometry = new THREE.PlaneBufferGeometry(20,20,segments,segments);
    this.plane_material = new THREE.ShaderMaterial({
      vertexShader       : document.getElementById('shader-vertex-terrain-perlinsombrero').textContent,
      fragmentShader     : document.getElementById('shader-fragment-terrain').textContent,
      wireframe          : this.options.wireframe,
      wireframeLinewidth : 1,
      transparent        : true,
      uniforms           : this.uniforms
    });
    //this.groundMaterial = new THREE.MeshPhongMaterial( { ambient: 0xffffff, color: 0xffffff, specular: 0x050505 } );
    //this.groundMaterial.visible = this.options.floor_visible;
    //this.groundMaterial.color.setHSL( 0.095, 1, 0.75 );;
    this.materials = [
     //this.groundMaterial,
     this.plane_material
    ];
    this.plane_mesh = THREE.SceneUtils.createMultiMaterialObject( this.plane_geometry, this.materials );
    this.plane_mesh.rotation.x = - Math.PI / 2;
    return this.plane_mesh.position.y = -0.5;
  }

  update() {
    return this.plane_material.uniforms['time'].value = this.clock.getElapsedTime();
  }
}

Terrain.initClass();
export default Terrain;



// WEBPACK FOOTER //
// ./src/lib/Terrain.js